import React from 'react'
import { CircularProgress, Paper, Typography } from '@material-ui/core'
import { useTranslation } from '@/langs/useTranslation'
import { FormItem } from '@/components/Form'
import { TextInput } from './Compo'

const DeviceCenter = ({ value, onChange, loading }) => {
  const { t } = useTranslation()

  return (
    <Paper elevation={0} style={{ backgroundColor: "#F8F9FC", borderRadius: "10px", marginTop: 24 }}>
      <Typography variant="h5" style={{marginBottom: 24}}>
        5. {t({ defaultMessage: "替换设备中心关键字" })}
        {loading && <CircularProgress size={22} style={{marginLeft: 16}} />}
      </Typography>
      <TextInput
        number="5.1"
        title="Cloud"
        value={value.nubisText}
        name="deviceCenter.nubisText"
        placeholder={t({defaultMessage: "例：Cloud"})}
        onChange={onChange}
        disabled={loading}
      />
      <TextInput
        number="5.2"
        title="Agent"
        value={value.oraText}
        name="deviceCenter.oraText"
        placeholder={t({defaultMessage: "例：Agent"})}
        onChange={onChange}
        disabled={loading}
      />
    </Paper>
  )
}

export default DeviceCenter